// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/account_address.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Contact } from "./contact_pb.js";
import { file_crm_v1_contact } from "./contact_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/account_address.proto.
 */
export const file_crm_v1_account_address: GenFile = /*@__PURE__*/
  fileDesc("Chxjcm0vdjEvYWNjb3VudF9hZGRyZXNzLnByb3RvEgZjcm0udjEivwUKDkFjY291bnRBZGRyZXNzEhUKAmlkGAEgASgLMgkudHlwZXMuSUQSHQoKYWNjb3VudF9pZBgCIAEoCzIJLnR5cGVzLklEEgwKBG5hbWUYAyABKAkSFAoMYWRkcmVzc190eXBlGAQgASgJEhYKDnN0cmVldF9hZGRyZXNzGAUgASgJEhcKD3N0cmVldF9hZGRyZXNzMhgGIAEoCRIMCgRjaXR5GAcgASgJEg0KBXN0YXRlGAggASgJEhMKC3Bvc3RhbF9jb2RlGAkgASgJEg8KB2NvdW50cnkYCiABKAkSGgoSaXNfbWFpbGluZ19hZGRyZXNzGAsgASgIEhAKCGxhdGl0dWRlGAwgASgJEhEKCWxvbmdpdHVkZRgNIAEoCRJHChFjdXN0b21fYXR0cmlidXRlcxgOIAMoCzIsLmNybS52MS5BY2NvdW50QWRkcmVzcy5DdXN0b21BdHRyaWJ1dGVzRW50cnkSMgoNbG9jYXRpb25fdHlwZRgPIAEoDjIbLmNybS52MS5BZGRyZXNzTG9jYXRpb25UeXBlEkMKD29wZXJhdGluZ19ob3VycxgQIAMoCzIqLmNybS52MS5BY2NvdW50QWRkcmVzcy5PcGVyYXRpbmdIb3Vyc0VudHJ5EhkKBGJhc2UYESABKAsyCy50eXBlcy5CYXNlEiEKCGNvbnRhY3RzGBIgAygLMg8uY3JtLnYxLkNvbnRhY3QaTwoVQ3VzdG9tQXR0cmlidXRlc0VudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAEaTQoTT3BlcmF0aW5nSG91cnNFbnRyeRILCgNrZXkYASABKAkSJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWU6AjgBIlUKGEdldEFjY291bnRBZGRyZXNzUmVxdWVzdBIVCgJpZBgBIAEoCzIJLnR5cGVzLklEEiIKD29yZ2FuaXphdGlvbl9pZBgCIAEoCzIJLnR5cGVzLklEIkwKGUdldEFjY291bnRBZGRyZXNzUmVzcG9uc2USLwoPYWNjb3VudF9hZGRyZXNzGAEgASgLMhYuY3JtLnYxLkFjY291bnRBZGRyZXNzIqMBChtMaXN0QWNjb3VudEFkZHJlc3Nlc1JlcXVlc3QSMgoGZmlsdGVyGAEgASgLMiIuY3JtLnYxLkxpc3RBY2NvdW50QWRkcmVzc2VzRmlsdGVyEjEKB3NvcnRpbmcYAiADKA4yIC5jcm0udjEuQWNjb3VudEFkZHJlc3NTb3J0T3B0aW9uEg4KBm9mZnNldBgDIAEoBRINCgVsaW1pdBgEIAEoBSL7BQoaTGlzdEFjY291bnRBZGRyZXNzZXNGaWx0ZXISFgoDaWRzGAEgAygLMgkudHlwZXMuSUQSMAoKYWNjb3VudF9pZBgCIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIqCgRuYW1lGAMgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjIKDGFkZHJlc3NfdHlwZRgEIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI0Cg5zdHJlZXRfYWRkcmVzcxgFIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRI1Cg9zdHJlZXRfYWRkcmVzczIYBiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSKgoEY2l0eRgHIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIrCgVzdGF0ZRgIIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIxCgtwb3N0YWxfY29kZRgJIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRItCgdjb3VudHJ5GAogASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjIKDWxvY2F0aW9uX3R5cGUYDyABKA4yGy5jcm0udjEuQWRkcmVzc0xvY2F0aW9uVHlwZRIxCgtzZWFyY2hfdGVybRgRIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIiCg9vcmdhbml6YXRpb25faWQYEiABKAsyCS50eXBlcy5JRBIeChZzZWFyY2hfYnlfYWNjb3VudF9uYW1lGBQgASgIEi8KC2lzX3N1cHBsaWVyGBUgASgLMhouZ29vZ2xlLnByb3RvYnVmLkJvb2xWYWx1ZRIvCgtpc19jdXN0b21lchgWIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5Cb29sVmFsdWUiYAocTGlzdEFjY291bnRBZGRyZXNzZXNSZXNwb25zZRIxChFhY2NvdW50X2FkZHJlc3NlcxgBIAMoCzIWLmNybS52MS5BY2NvdW50QWRkcmVzcxINCgV0b3RhbBgCIAEoBSJtChtDcmVhdGVBY2NvdW50QWRkcmVzc1JlcXVlc3QSKgoFaW5wdXQYASABKAsyGy5jcm0udjEuQWNjb3VudEFkZHJlc3NJbnB1dBIiCg9vcmdhbml6YXRpb25faWQYAiABKAsyCS50eXBlcy5JRCJPChxDcmVhdGVBY2NvdW50QWRkcmVzc1Jlc3BvbnNlEi8KD2FjY291bnRfYWRkcmVzcxgBIAEoCzIWLmNybS52MS5BY2NvdW50QWRkcmVzcyKKAQobVXBkYXRlQWNjb3VudEFkZHJlc3NSZXF1ZXN0EhUKAmlkGAEgASgLMgkudHlwZXMuSUQSMAoFaW5wdXQYAiABKAsyIS5jcm0udjEuQWNjb3VudEFkZHJlc3NVcGRhdGVJbnB1dBIiCg9vcmdhbml6YXRpb25faWQYAyABKAsyCS50eXBlcy5JRCJPChxVcGRhdGVBY2NvdW50QWRkcmVzc1Jlc3BvbnNlEi8KD2FjY291bnRfYWRkcmVzcxgBIAEoCzIWLmNybS52MS5BY2NvdW50QWRkcmVzcyJYChtEZWxldGVBY2NvdW50QWRkcmVzc1JlcXVlc3QSFQoCaWQYASABKAsyCS50eXBlcy5JRBIiCg9vcmdhbml6YXRpb25faWQYAiABKAsyCS50eXBlcy5JRCKQBQoTQWNjb3VudEFkZHJlc3NJbnB1dBIVCgJpZBgBIAEoCzIJLnR5cGVzLklEEh0KCmFjY291bnRfaWQYAiABKAsyCS50eXBlcy5JRBIMCgRuYW1lGAMgASgJEhQKDGFkZHJlc3NfdHlwZRgEIAEoCRIWCg5zdHJlZXRfYWRkcmVzcxgFIAEoCRIXCg9zdHJlZXRfYWRkcmVzczIYBiABKAkSDAoEY2l0eRgHIAEoCRINCgVzdGF0ZRgIIAEoCRITCgtwb3N0YWxfY29kZRgJIAEoCRIPCgdjb3VudHJ5GAogASgJEhoKEmlzX21haWxpbmdfYWRkcmVzcxgLIAEoCBIQCghsYXRpdHVkZRgMIAEoCRIRCglsb25naXR1ZGUYDSABKAkSTAoRY3VzdG9tX2F0dHJpYnV0ZXMYDiADKAsyMS5jcm0udjEuQWNjb3VudEFkZHJlc3NJbnB1dC5DdXN0b21BdHRyaWJ1dGVzRW50cnkSMgoNbG9jYXRpb25fdHlwZRgPIAEoDjIbLmNybS52MS5BZGRyZXNzTG9jYXRpb25UeXBlEkgKD29wZXJhdGluZ19ob3VycxgQIAMoCzIvLmNybS52MS5BY2NvdW50QWRkcmVzc0lucHV0Lk9wZXJhdGluZ0hvdXJzRW50cnkaTwoVQ3VzdG9tQXR0cmlidXRlc0VudHJ5EgsKA2tleRgBIAEoCRIlCgV2YWx1ZRgCIAEoCzIWLmdvb2dsZS5wcm90b2J1Zi5WYWx1ZToCOAEaTQoTT3BlcmF0aW5nSG91cnNFbnRyeRILCgNrZXkYASABKAkSJQoFdmFsdWUYAiABKAsyFi5nb29nbGUucHJvdG9idWYuVmFsdWU6AjgBIuAFChlBY2NvdW50QWRkcmVzc1VwZGF0ZUlucHV0EioKBG5hbWUYASABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSMgoMYWRkcmVzc190eXBlGAIgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjQKDnN0cmVldF9hZGRyZXNzGAMgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjUKD3N0cmVldF9hZGRyZXNzMhgEIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIqCgRjaXR5GAUgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEisKBXN0YXRlGAYgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjEKC3Bvc3RhbF9jb2RlGAcgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi0KB2NvdW50cnkYCCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSNgoSaXNfbWFpbGluZ19hZGRyZXNzGAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLkJvb2xWYWx1ZRIuCghsYXRpdHVkZRgKIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRIvCglsb25naXR1ZGUYCyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSNwoRY3VzdG9tX2F0dHJpYnV0ZXMYDCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSMgoNbG9jYXRpb25fdHlwZRgNIAEoDjIbLmNybS52MS5BZGRyZXNzTG9jYXRpb25UeXBlEjUKD29wZXJhdGluZ19ob3VycxgOIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZSKDAQorR2V0QWNjb3VudEFkZHJlc3Nlc0J5Q3VzdG9tQXR0cmlidXRlUmVxdWVzdBIWCg5hdHRyaWJ1dGVfbmFtZRgBIAEoCRIYChBhdHRyaWJ1dGVfdmFsdWVzGAIgAygJEiIKD29yZ2FuaXphdGlvbl9pZBgDIAEoCzIJLnR5cGVzLklEIlYKLEdldEFjY291bnRBZGRyZXNzZXNCeUN1c3RvbUF0dHJpYnV0ZVJlc3BvbnNlEiYKBnJlc3VsdBgBIAMoCzIWLmNybS52MS5BY2NvdW50QWRkcmVzcyruAQoTQWRkcmVzc0xvY2F0aW9uVHlwZRIlCiFBRERSRVNTX0xPQ0FUSU9OX1RZUEVfVU5TUEVDSUZJRUQQABIiCh5BRERSRVNTX0xPQ0FUSU9OX1RZUEVfU0hJUFBJTkcQARIhCh1BRERSRVNTX0xPQ0FUSU9OX1RZUEVfQklMTElORxACEiAKHEFERFJFU1NfTE9DQVRJT05fVFlQRV9QSUNLVVAQAxIiCh5BRERSRVNTX0xPQ0FUSU9OX1RZUEVfREVMSVZFUlkQBBIjCh9BRERSRVNTX0xPQ0FUSU9OX1RZUEVfV0FSRUhPVVNFEAUqzQYKGEFjY291bnRBZGRyZXNzU29ydE9wdGlvbhIrCidBQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fVU5TUEVDSUZJRUQQABIwCixBQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fQUREUkVTU19UWVBFX0FTQxABEjEKLUFDQ09VTlRfQUREUkVTU19TT1JUX09QVElPTl9BRERSRVNTX1RZUEVfREVTQxACEigKJEFDQ09VTlRfQUREUkVTU19TT1JUX09QVElPTl9DSVRZX0FTQxADEikKJUFDQ09VTlRfQUREUkVTU19TT1JUX09QVElPTl9DSVRZX0RFU0MQBBIpCiVBQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fU1RBVEVfQVNDEAUSKgomQUNDT1VOVF9BRERSRVNTX1NPUlRfT1BUSU9OX1NUQVRFX0RFU0MQBhIrCidBQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fQ09VTlRSWV9BU0MQBxIsCihBQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fQ09VTlRSWV9ERVNDEAgSNgoyQUNDT1VOVF9BRERSRVNTX1NPUlRfT1BUSU9OX0lTX01BSUxJTkdfQUREUkVTU19BU0MQCRI3CjNBQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fSVNfTUFJTElOR19BRERSRVNTX0RFU0MQChIxCi1BQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fTE9DQVRJT05fVFlQRV9BU0MQCxIyCi5BQ0NPVU5UX0FERFJFU1NfU09SVF9PUFRJT05fTE9DQVRJT05fVFlQRV9ERVNDEAwSLgoqQUNDT1VOVF9BRERSRVNTX1NPUlRfT1BUSU9OX0NSRUFURURfQVRfQVNDEA0SLworQUNDT1VOVF9BRERSRVNTX1NPUlRfT1BUSU9OX0NSRUFURURfQVRfREVTQxAOEi4KKkFDQ09VTlRfQUREUkVTU19TT1JUX09QVElPTl9VUERBVEVEX0FUX0FTQxAPEi8KK0FDQ09VTlRfQUREUkVTU19TT1JUX09QVElPTl9VUERBVEVEX0FUX0RFU0MQEDLvAgocQWNjb3VudEFkZHJlc3NRdWVyaWVzU2VydmljZRJYChFHZXRBY2NvdW50QWRkcmVzcxIgLmNybS52MS5HZXRBY2NvdW50QWRkcmVzc1JlcXVlc3QaIS5jcm0udjEuR2V0QWNjb3VudEFkZHJlc3NSZXNwb25zZRJhChRMaXN0QWNjb3VudEFkZHJlc3NlcxIjLmNybS52MS5MaXN0QWNjb3VudEFkZHJlc3Nlc1JlcXVlc3QaJC5jcm0udjEuTGlzdEFjY291bnRBZGRyZXNzZXNSZXNwb25zZRKRAQokR2V0QWNjb3VudEFkZHJlc3Nlc0J5Q3VzdG9tQXR0cmlidXRlEjMuY3JtLnYxLkdldEFjY291bnRBZGRyZXNzZXNCeUN1c3RvbUF0dHJpYnV0ZVJlcXVlc3QaNC5jcm0udjEuR2V0QWNjb3VudEFkZHJlc3Nlc0J5Q3VzdG9tQXR0cmlidXRlUmVzcG9uc2UyugIKHUFjY291bnRBZGRyZXNzQ29tbWFuZHNTZXJ2aWNlEmEKFENyZWF0ZUFjY291bnRBZGRyZXNzEiMuY3JtLnYxLkNyZWF0ZUFjY291bnRBZGRyZXNzUmVxdWVzdBokLmNybS52MS5DcmVhdGVBY2NvdW50QWRkcmVzc1Jlc3BvbnNlEmEKFFVwZGF0ZUFjY291bnRBZGRyZXNzEiMuY3JtLnYxLlVwZGF0ZUFjY291bnRBZGRyZXNzUmVxdWVzdBokLmNybS52MS5VcGRhdGVBY2NvdW50QWRkcmVzc1Jlc3BvbnNlElMKFERlbGV0ZUFjY291bnRBZGRyZXNzEiMuY3JtLnYxLkRlbGV0ZUFjY291bnRBZGRyZXNzUmVxdWVzdBoWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eUIrWilwYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS1jcm0vYXBpL3YxO2NybV92MWIIZWRpdGlvbnNw6Ac", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types, file_crm_v1_contact]);

/**
 * AccountAddress message definition
 *
 * @generated from message crm.v1.AccountAddress
 */
export type AccountAddress = Message<"crm.v1.AccountAddress"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_id = 2;
   */
  accountId?: ID;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string address_type = 4;
   */
  addressType: string;

  /**
   * @generated from field: string street_address = 5;
   */
  streetAddress: string;

  /**
   * @generated from field: string street_address2 = 6;
   */
  streetAddress2: string;

  /**
   * @generated from field: string city = 7;
   */
  city: string;

  /**
   * @generated from field: string state = 8;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 9;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 10;
   */
  country: string;

  /**
   * @generated from field: bool is_mailing_address = 11;
   */
  isMailingAddress: boolean;

  /**
   * @generated from field: string latitude = 12;
   */
  latitude: string;

  /**
   * @generated from field: string longitude = 13;
   */
  longitude: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 14;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: crm.v1.AddressLocationType location_type = 15;
   */
  locationType: AddressLocationType;

  /**
   * @generated from field: map<string, google.protobuf.Value> operating_hours = 16;
   */
  operatingHours: { [key: string]: Value };

  /**
   * @generated from field: types.Base base = 17;
   */
  base?: Base;

  /**
   * @generated from field: repeated crm.v1.Contact contacts = 18;
   */
  contacts: Contact[];
};

/**
 * Describes the message crm.v1.AccountAddress.
 * Use `create(AccountAddressSchema)` to create a new message.
 */
export const AccountAddressSchema: GenMessage<AccountAddress> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 0);

/**
 * Request/Response messages for AccountAddress queries
 *
 * @generated from message crm.v1.GetAccountAddressRequest
 */
export type GetAccountAddressRequest = Message<"crm.v1.GetAccountAddressRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetAccountAddressRequest.
 * Use `create(GetAccountAddressRequestSchema)` to create a new message.
 */
export const GetAccountAddressRequestSchema: GenMessage<GetAccountAddressRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 1);

/**
 * @generated from message crm.v1.GetAccountAddressResponse
 */
export type GetAccountAddressResponse = Message<"crm.v1.GetAccountAddressResponse"> & {
  /**
   * @generated from field: crm.v1.AccountAddress account_address = 1;
   */
  accountAddress?: AccountAddress;
};

/**
 * Describes the message crm.v1.GetAccountAddressResponse.
 * Use `create(GetAccountAddressResponseSchema)` to create a new message.
 */
export const GetAccountAddressResponseSchema: GenMessage<GetAccountAddressResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 2);

/**
 * @generated from message crm.v1.ListAccountAddressesRequest
 */
export type ListAccountAddressesRequest = Message<"crm.v1.ListAccountAddressesRequest"> & {
  /**
   * @generated from field: crm.v1.ListAccountAddressesFilter filter = 1;
   */
  filter?: ListAccountAddressesFilter;

  /**
   * @generated from field: repeated crm.v1.AccountAddressSortOption sorting = 2;
   */
  sorting: AccountAddressSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message crm.v1.ListAccountAddressesRequest.
 * Use `create(ListAccountAddressesRequestSchema)` to create a new message.
 */
export const ListAccountAddressesRequestSchema: GenMessage<ListAccountAddressesRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 3);

/**
 * @generated from message crm.v1.ListAccountAddressesFilter
 */
export type ListAccountAddressesFilter = Message<"crm.v1.ListAccountAddressesFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue account_id = 2;
   */
  accountId?: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 3;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue address_type = 4;
   */
  addressType?: string;

  /**
   * @generated from field: google.protobuf.StringValue street_address = 5;
   */
  streetAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue street_address2 = 6;
   */
  streetAddress2?: string;

  /**
   * @generated from field: google.protobuf.StringValue city = 7;
   */
  city?: string;

  /**
   * @generated from field: google.protobuf.StringValue state = 8;
   */
  state?: string;

  /**
   * @generated from field: google.protobuf.StringValue postal_code = 9;
   */
  postalCode?: string;

  /**
   * @generated from field: google.protobuf.StringValue country = 10;
   */
  country?: string;

  /**
   * @generated from field: crm.v1.AddressLocationType location_type = 15;
   */
  locationType: AddressLocationType;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 17;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 18;
   */
  organizationId?: ID;

  /**
   * @generated from field: bool search_by_account_name = 20;
   */
  searchByAccountName: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue is_supplier = 21;
   */
  isSupplier?: boolean;

  /**
   * @generated from field: google.protobuf.BoolValue is_customer = 22;
   */
  isCustomer?: boolean;
};

/**
 * Describes the message crm.v1.ListAccountAddressesFilter.
 * Use `create(ListAccountAddressesFilterSchema)` to create a new message.
 */
export const ListAccountAddressesFilterSchema: GenMessage<ListAccountAddressesFilter> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 4);

/**
 * @generated from message crm.v1.ListAccountAddressesResponse
 */
export type ListAccountAddressesResponse = Message<"crm.v1.ListAccountAddressesResponse"> & {
  /**
   * @generated from field: repeated crm.v1.AccountAddress account_addresses = 1;
   */
  accountAddresses: AccountAddress[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message crm.v1.ListAccountAddressesResponse.
 * Use `create(ListAccountAddressesResponseSchema)` to create a new message.
 */
export const ListAccountAddressesResponseSchema: GenMessage<ListAccountAddressesResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 5);

/**
 * Command messages
 *
 * @generated from message crm.v1.CreateAccountAddressRequest
 */
export type CreateAccountAddressRequest = Message<"crm.v1.CreateAccountAddressRequest"> & {
  /**
   * @generated from field: crm.v1.AccountAddressInput input = 1;
   */
  input?: AccountAddressInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.CreateAccountAddressRequest.
 * Use `create(CreateAccountAddressRequestSchema)` to create a new message.
 */
export const CreateAccountAddressRequestSchema: GenMessage<CreateAccountAddressRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 6);

/**
 * @generated from message crm.v1.CreateAccountAddressResponse
 */
export type CreateAccountAddressResponse = Message<"crm.v1.CreateAccountAddressResponse"> & {
  /**
   * @generated from field: crm.v1.AccountAddress account_address = 1;
   */
  accountAddress?: AccountAddress;
};

/**
 * Describes the message crm.v1.CreateAccountAddressResponse.
 * Use `create(CreateAccountAddressResponseSchema)` to create a new message.
 */
export const CreateAccountAddressResponseSchema: GenMessage<CreateAccountAddressResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 7);

/**
 * @generated from message crm.v1.UpdateAccountAddressRequest
 */
export type UpdateAccountAddressRequest = Message<"crm.v1.UpdateAccountAddressRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: crm.v1.AccountAddressUpdateInput input = 2;
   */
  input?: AccountAddressUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.UpdateAccountAddressRequest.
 * Use `create(UpdateAccountAddressRequestSchema)` to create a new message.
 */
export const UpdateAccountAddressRequestSchema: GenMessage<UpdateAccountAddressRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 8);

/**
 * @generated from message crm.v1.UpdateAccountAddressResponse
 */
export type UpdateAccountAddressResponse = Message<"crm.v1.UpdateAccountAddressResponse"> & {
  /**
   * @generated from field: crm.v1.AccountAddress account_address = 1;
   */
  accountAddress?: AccountAddress;
};

/**
 * Describes the message crm.v1.UpdateAccountAddressResponse.
 * Use `create(UpdateAccountAddressResponseSchema)` to create a new message.
 */
export const UpdateAccountAddressResponseSchema: GenMessage<UpdateAccountAddressResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 9);

/**
 * @generated from message crm.v1.DeleteAccountAddressRequest
 */
export type DeleteAccountAddressRequest = Message<"crm.v1.DeleteAccountAddressRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.DeleteAccountAddressRequest.
 * Use `create(DeleteAccountAddressRequestSchema)` to create a new message.
 */
export const DeleteAccountAddressRequestSchema: GenMessage<DeleteAccountAddressRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 10);

/**
 * Input messages
 *
 * @generated from message crm.v1.AccountAddressInput
 */
export type AccountAddressInput = Message<"crm.v1.AccountAddressInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_id = 2;
   */
  accountId?: ID;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string address_type = 4;
   */
  addressType: string;

  /**
   * @generated from field: string street_address = 5;
   */
  streetAddress: string;

  /**
   * @generated from field: string street_address2 = 6;
   */
  streetAddress2: string;

  /**
   * @generated from field: string city = 7;
   */
  city: string;

  /**
   * @generated from field: string state = 8;
   */
  state: string;

  /**
   * @generated from field: string postal_code = 9;
   */
  postalCode: string;

  /**
   * @generated from field: string country = 10;
   */
  country: string;

  /**
   * @generated from field: bool is_mailing_address = 11;
   */
  isMailingAddress: boolean;

  /**
   * @generated from field: string latitude = 12;
   */
  latitude: string;

  /**
   * @generated from field: string longitude = 13;
   */
  longitude: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 14;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: crm.v1.AddressLocationType location_type = 15;
   */
  locationType: AddressLocationType;

  /**
   * @generated from field: map<string, google.protobuf.Value> operating_hours = 16;
   */
  operatingHours: { [key: string]: Value };
};

/**
 * Describes the message crm.v1.AccountAddressInput.
 * Use `create(AccountAddressInputSchema)` to create a new message.
 */
export const AccountAddressInputSchema: GenMessage<AccountAddressInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 11);

/**
 * @generated from message crm.v1.AccountAddressUpdateInput
 */
export type AccountAddressUpdateInput = Message<"crm.v1.AccountAddressUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue name = 1;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue address_type = 2;
   */
  addressType?: string;

  /**
   * @generated from field: google.protobuf.StringValue street_address = 3;
   */
  streetAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue street_address2 = 4;
   */
  streetAddress2?: string;

  /**
   * @generated from field: google.protobuf.StringValue city = 5;
   */
  city?: string;

  /**
   * @generated from field: google.protobuf.StringValue state = 6;
   */
  state?: string;

  /**
   * @generated from field: google.protobuf.StringValue postal_code = 7;
   */
  postalCode?: string;

  /**
   * @generated from field: google.protobuf.StringValue country = 8;
   */
  country?: string;

  /**
   * @generated from field: google.protobuf.BoolValue is_mailing_address = 9;
   */
  isMailingAddress?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue latitude = 10;
   */
  latitude?: string;

  /**
   * @generated from field: google.protobuf.StringValue longitude = 11;
   */
  longitude?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 12;
   */
  customAttributes?: string;

  /**
   * @generated from field: crm.v1.AddressLocationType location_type = 13;
   */
  locationType: AddressLocationType;

  /**
   * @generated from field: google.protobuf.StringValue operating_hours = 14;
   */
  operatingHours?: string;
};

/**
 * Describes the message crm.v1.AccountAddressUpdateInput.
 * Use `create(AccountAddressUpdateInputSchema)` to create a new message.
 */
export const AccountAddressUpdateInputSchema: GenMessage<AccountAddressUpdateInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 12);

/**
 * GetAccountAddressesByCustomAttributeRequest - custom query request
 *
 * @generated from message crm.v1.GetAccountAddressesByCustomAttributeRequest
 */
export type GetAccountAddressesByCustomAttributeRequest = Message<"crm.v1.GetAccountAddressesByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetAccountAddressesByCustomAttributeRequest.
 * Use `create(GetAccountAddressesByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetAccountAddressesByCustomAttributeRequestSchema: GenMessage<GetAccountAddressesByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 13);

/**
 * GetAccountAddressesByCustomAttributeResponse - custom query response
 *
 * @generated from message crm.v1.GetAccountAddressesByCustomAttributeResponse
 */
export type GetAccountAddressesByCustomAttributeResponse = Message<"crm.v1.GetAccountAddressesByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated crm.v1.AccountAddress result = 1;
   */
  result: AccountAddress[];
};

/**
 * Describes the message crm.v1.GetAccountAddressesByCustomAttributeResponse.
 * Use `create(GetAccountAddressesByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetAccountAddressesByCustomAttributeResponseSchema: GenMessage<GetAccountAddressesByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_account_address, 14);

/**
 * AddressLocationType enum
 *
 * @generated from enum crm.v1.AddressLocationType
 */
export enum AddressLocationType {
  /**
   * @generated from enum value: ADDRESS_LOCATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ADDRESS_LOCATION_TYPE_SHIPPING = 1;
   */
  SHIPPING = 1,

  /**
   * @generated from enum value: ADDRESS_LOCATION_TYPE_BILLING = 2;
   */
  BILLING = 2,

  /**
   * @generated from enum value: ADDRESS_LOCATION_TYPE_PICKUP = 3;
   */
  PICKUP = 3,

  /**
   * @generated from enum value: ADDRESS_LOCATION_TYPE_DELIVERY = 4;
   */
  DELIVERY = 4,

  /**
   * @generated from enum value: ADDRESS_LOCATION_TYPE_WAREHOUSE = 5;
   */
  WAREHOUSE = 5,
}

/**
 * Describes the enum crm.v1.AddressLocationType.
 */
export const AddressLocationTypeSchema: GenEnum<AddressLocationType> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_address, 0);

/**
 * @generated from enum crm.v1.AccountAddressSortOption
 */
export enum AccountAddressSortOption {
  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_ADDRESS_TYPE_ASC = 1;
   */
  ADDRESS_TYPE_ASC = 1,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_ADDRESS_TYPE_DESC = 2;
   */
  ADDRESS_TYPE_DESC = 2,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_CITY_ASC = 3;
   */
  CITY_ASC = 3,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_CITY_DESC = 4;
   */
  CITY_DESC = 4,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_STATE_ASC = 5;
   */
  STATE_ASC = 5,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_STATE_DESC = 6;
   */
  STATE_DESC = 6,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_COUNTRY_ASC = 7;
   */
  COUNTRY_ASC = 7,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_COUNTRY_DESC = 8;
   */
  COUNTRY_DESC = 8,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_IS_MAILING_ADDRESS_ASC = 9;
   */
  IS_MAILING_ADDRESS_ASC = 9,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_IS_MAILING_ADDRESS_DESC = 10;
   */
  IS_MAILING_ADDRESS_DESC = 10,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_LOCATION_TYPE_ASC = 11;
   */
  LOCATION_TYPE_ASC = 11,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_LOCATION_TYPE_DESC = 12;
   */
  LOCATION_TYPE_DESC = 12,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_CREATED_AT_ASC = 13;
   */
  CREATED_AT_ASC = 13,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_CREATED_AT_DESC = 14;
   */
  CREATED_AT_DESC = 14,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_UPDATED_AT_ASC = 15;
   */
  UPDATED_AT_ASC = 15,

  /**
   * @generated from enum value: ACCOUNT_ADDRESS_SORT_OPTION_UPDATED_AT_DESC = 16;
   */
  UPDATED_AT_DESC = 16,
}

/**
 * Describes the enum crm.v1.AccountAddressSortOption.
 */
export const AccountAddressSortOptionSchema: GenEnum<AccountAddressSortOption> = /*@__PURE__*/
  enumDesc(file_crm_v1_account_address, 1);

/**
 * Services
 *
 * @generated from service crm.v1.AccountAddressQueriesService
 */
export const AccountAddressQueriesService: GenService<{
  /**
   * @generated from rpc crm.v1.AccountAddressQueriesService.GetAccountAddress
   */
  getAccountAddress: {
    methodKind: "unary";
    input: typeof GetAccountAddressRequestSchema;
    output: typeof GetAccountAddressResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountAddressQueriesService.ListAccountAddresses
   */
  listAccountAddresses: {
    methodKind: "unary";
    input: typeof ListAccountAddressesRequestSchema;
    output: typeof ListAccountAddressesResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountAddressQueriesService.GetAccountAddressesByCustomAttribute
   */
  getAccountAddressesByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetAccountAddressesByCustomAttributeRequestSchema;
    output: typeof GetAccountAddressesByCustomAttributeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account_address, 0);

/**
 * @generated from service crm.v1.AccountAddressCommandsService
 */
export const AccountAddressCommandsService: GenService<{
  /**
   * @generated from rpc crm.v1.AccountAddressCommandsService.CreateAccountAddress
   */
  createAccountAddress: {
    methodKind: "unary";
    input: typeof CreateAccountAddressRequestSchema;
    output: typeof CreateAccountAddressResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountAddressCommandsService.UpdateAccountAddress
   */
  updateAccountAddress: {
    methodKind: "unary";
    input: typeof UpdateAccountAddressRequestSchema;
    output: typeof UpdateAccountAddressResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.AccountAddressCommandsService.DeleteAccountAddress
   */
  deleteAccountAddress: {
    methodKind: "unary";
    input: typeof DeleteAccountAddressRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_account_address, 1);

